import { render, staticRenderFns } from "./Cooperate.vue?vue&type=template&id=51be9c4f&scoped=true&"
import script from "./Cooperate.vue?vue&type=script&lang=js&"
export * from "./Cooperate.vue?vue&type=script&lang=js&"
import style0 from "./Cooperate.vue?vue&type=style&index=0&id=51be9c4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51be9c4f",
  null
  
)

export default component.exports